import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import API from '@resi-media/api-types';

export const root = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    query: {} as { endTime?: string; mediaId?: string; startTime?: string; webEventProfileId?: string },
    responseSchema: API.Central.V3.Schedules.Get.List,
    url: `${CENTRAL_API_V3}/customers/@customerId/schedules`,
  },
  [HTTP_METHODS.POST]: {
    method: HTTP_METHODS.POST,
    request: {} as API.Central.V3.Schedules.Post.Create.Request,
    url: `${CENTRAL_API_V3}/customers/@customerId/schedules`,
  },
  [HTTP_METHODS.DELETE]: {
    method: HTTP_METHODS.DELETE,
    query: {} as { mediaId?: string; webEventProfileId?: string },
    url: `${CENTRAL_API_V3}/customers/@customerId/schedules`,
  },
};

export const id = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    query: {} as { endTime?: string; startTime?: string },
    params: {} as { id: string },
    responseSchema: API.Central.V3.Schedules.Get.ById,
    url: `${CENTRAL_API_V3}/customers/@customerId/schedules/@id`,
  },
  [HTTP_METHODS.PUT]: {
    method: HTTP_METHODS.PUT,
    params: {} as { id: string },
    request: {} as API.Central.V3.Schedules.Put.Request,
    url: `${CENTRAL_API_V3}/customers/@customerId/schedules/@id`,
  },
  [HTTP_METHODS.DELETE]: {
    method: HTTP_METHODS.DELETE,
    params: {} as { id: string },
    url: `${CENTRAL_API_V3}/customers/@customerId/schedules/@id`,
  },
};
